import { push } from 'react-router-redux';

export const goTo = (route) => (dispatch) => {
    dispatch(push(route));
};



// WEBPACK FOOTER //
// ./src/app/shared/utils/NavigationActions.js